import { cn } from "../../shared/utils";

interface BasePageWrapProps {
    customStyles?: string;
    children: React.ReactNode;
}

export default function BasePageWrap({ customStyles, children }: BasePageWrapProps) {
    return (
        <div className={cn("ecotic-page-wrap", customStyles)}>
            {children}
        </div>
    );
}
